// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"66878557","74":"81e09bbe","187":"e8315a6e","243":"a73ad16d","305":"aae0cfd7","378":"cc19cc20","415":"f35008d5","453":"b2dfebad","629":"6495666d","700":"958b775f","783":"155caf85"}[chunkId] + ".chunk.js";
};